var NINJA = NINJA || {};

NINJA.TEMPLATES = {
  CLEAN: "1",
  BOLD: "2",
  MODERN: "3",
  NORMAL: "4",
  BUSINESS: "5",
  CREATIVE: "6",
  ELEGANT: "7",
  HIPSTER: "8",
  PLAYFUL: "9",
  PHOTO: "10",
};

function GetPdfMake(invoice, javascript, callback) {
  // check if we need to add a second table for tasks
  var itemsTable = false;
  if (invoice.hasSecondTable) {
    var json = JSON.parse(javascript);
    for (var i = 0; i < json.content.length; i++) {
      var item = json.content[i];
      if (item.table && item.table.body == "$invoiceLineItems") {
        itemsTable = JSON.stringify(item);
        itemsTable = itemsTable.replace("$invoiceLineItems", "$taskLineItems");
        //itemsTable = itemsTable.replace('$invoiceLineItemColumns', '$taskLineItemColumns');
        break;
      }
    }
    itemsTable = JSON.parse(itemsTable);
    json.content.splice(i + 1, 0, itemsTable);
    javascript = JSON.stringify(json);
  }

  javascript = NINJA.decodeJavascript(invoice, javascript);

  function jsonCallBack(key, val) {
    // handle custom functions
    if (typeof val === "string") {
      if (val.indexOf("$firstAndLast") === 0) {
        var parts = val.split(":");
        return function (i, node) {
          return i === 0 || i === node.table.body.length
            ? parseFloat(parts[1])
            : 0;
        };
      } else if (val.indexOf("$none") === 0) {
        return function (i, node) {
          return 0;
        };
      } else if (val.indexOf("$notFirstAndLastColumn") === 0) {
        var parts = val.split(":");
        return function (i, node) {
          return i === 0 || i === node.table.widths.length
            ? 0
            : parseFloat(parts[1]);
        };
      } else if (val.indexOf("$notFirst") === 0) {
        var parts = val.split(":");
        return function (i, node) {
          return i === 0 ? 0 : parseFloat(parts[1]);
        };
      } else if (val.indexOf("$amount") === 0) {
        var parts = val.split(":");
        return function (i, node) {
          return parseFloat(parts[1]);
        };
      } else if (val.indexOf("$primaryColor") === 0) {
        var parts = val.split(":");
        return NINJA.primaryColor || parts[1];
      } else if (val.indexOf("$secondaryColor") === 0) {
        var parts = val.split(":");
        return NINJA.secondaryColor || parts[1];
      }
    }

    // determine whether or not to show the header/footer
    if (invoice.features.customize_invoice_design) {
      if (key === "header") {
        return function (page, pages) {
          if (page === 1 || invoice.account.all_pages_header == "1") {
            if (invoice.features.remove_created_by) {
              return NINJA.updatePageCount(
                JSON.parse(JSON.stringify(val)),
                page,
                pages
              );
            } else {
              return val;
            }
          } else {
            return "";
          }
        };
      } else if (key === "footer") {
        return function (page, pages) {
          if (page === pages || invoice.account.all_pages_footer == "1") {
            if (invoice.features.remove_created_by) {
              return NINJA.updatePageCount(
                JSON.parse(JSON.stringify(val)),
                page,
                pages
              );
            } else {
              return val;
            }
          } else {
            return "";
          }
        };
      }
    }

    // check for markdown
    if (key === "text") {
      val = NINJA.parseMarkdownText(val, true);
    }

    /*
         if (key === 'stack') {
         val = NINJA.parseMarkdownStack(val);
         val = NINJA.parseMarkdownText(val, false);
         }
         */

    return val;
  }

  // Add ninja logo to the footer
  var dd = JSON.parse(javascript, jsonCallBack);
  var designId = invoice.invoice_design_id;
  if (true || (!invoice.features.remove_created_by && !isEdge)) {
    var footer = typeof dd.footer === "function" ? dd.footer() : dd.footer;
    if (footer) {
      if (footer.hasOwnProperty("columns")) {
        footer.columns.push({
          image: logoImages.imageLogo1,
          alignment: "right",
          width: 130,
          margin: [0, 0, 0, 0],
        });
      } else {
        var foundColumns;
        for (var i = 0; i < footer.length; i++) {
          var item = footer[i];
          if (item.hasOwnProperty("columns")) {
            foundColumns = true;
            var columns = item.columns;
            if (columns[0].hasOwnProperty("stack")) {
              columns[0].stack.push({
                image: logoImages.imageLogo3,
                alignment: "left",
                width: 130,
                margin: [40, 6, 0, 0],
              });
            } else {
              columns.push({
                image: logoImages.imageLogo1,
                alignment: "right",
                width: 130,
                margin: [0, -40, 20, 0],
              });
            }
          }
        }
        if (!foundColumns) {
          footer.push({
            image: logoImages.imageLogo1,
            alignment: "right",
            width: 130,
            margin: [0, 0, 10, 10],
          });
        }
      }
    }
  }

  // set page size
  dd.pageSize = invoice.account.page_size;

  //dd.watermark = {text: 'PAID', color: 'blue', opacity: 0.3};

  pdfMake.fonts = {};
  fonts = window.invoiceFonts || invoice.invoice_fonts;

  // Add only the loaded fonts
  $.each(fonts, function (i, font) {
    addFont(font);
  });

  function addFont(font) {
    if (window.ninjaFontVfs[font.folder]) {
      folder = "fonts/" + font.folder;
      pdfMake.fonts[font.name] = {
        normal: folder + "/" + font.normal,
        italics: folder + "/" + font.italics,
        bold: folder + "/" + font.bold,
        bolditalics: folder + "/" + font.bolditalics,
      };
    }
  }

  if (!dd.defaultStyle) dd.defaultStyle = { font: NINJA.bodyFont };
  else if (!dd.defaultStyle.font) dd.defaultStyle.font = NINJA.bodyFont;
  doc = pdfMake.createPdf(dd);
  doc.save = function (fileName) {
    this.download(fileName);
  };

  return doc;
}

NINJA.updatePageCount = function (obj, pageNumber, pageCount) {
  var pageNumberRegExp = new RegExp("\\$pageNumber", "g");
  var pageCountRegExp = new RegExp("\\$pageCount", "g");

  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    var val = obj[key];
    if (typeof val === "string") {
      val = val.replace(pageNumberRegExp, pageNumber);
      val = val.replace(pageCountRegExp, pageCount);
      obj[key] = val;
    } else if (typeof val === "object") {
      obj[key] = NINJA.updatePageCount(val, pageNumber, pageCount);
    }
  }

  return obj;
};

NINJA.decodeJavascript = function (invoice, javascript) {
  var account = invoice.account;
  var blankImage =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=";

  var ninjaSubtotal = NINJA.subtotals(invoice, true);

  // search/replace variables
  var json = {
    accountName: account.name || " ",
    accountLogo:
      !isEdge && window.accountLogo ? window.accountLogo : blankImage,
    reportDuration: invoice.is_statement ? invoice.duration : " ",
    signature:
      !isEdge && window.signatureImage ? window.signatureImage : blankImage,
    footerImage:
      !isEdge && window.accountFooterImage
        ? window.accountFooterImage
        : blankImage,
    accountDetails: NINJA.accountDetails(invoice),
    accountAddress: NINJA.accountAddress(invoice),
    invoiceDetails: NINJA.invoiceDetails(invoice),
    invoiceDetailsHeight: NINJA.invoiceDetails(invoice).length * 16 + 16,
    invoiceLineItems: invoice.is_statement
      ? NINJA.statementLines(invoice)
      : NINJA.invoiceLines(invoice),
    invoiceLineItemColumns: invoice.is_statement
      ? NINJA.statementColumns(invoice)
      : NINJA.invoiceColumns(invoice),
    taskLineItems: NINJA.invoiceLines(invoice, true),
    //'taskLineItemColumns': NINJA.invoiceColumns(invoice),
    invoiceDocuments: isEdge ? [] : NINJA.invoiceDocuments(invoice),
    quantityWidth: NINJA.quantityWidth(invoice),
    taxWidth: NINJA.taxWidth(invoice),
    clientDetails: NINJA.clientDetails(invoice),
    deliveryDetails: NINJA.deliveryDetails(invoice),
    deliveryAddressLabel:
      invoice.deliveryaddress && invoice.deliveryaddress.public_id
        ? "Delivery Details"
        : " ",
    notesAndTerms: NINJA.notesAndTerms(invoice),
    subtotals: invoice.is_statement
      ? NINJA.statementSubtotals(invoice)
      : ninjaSubtotal,
    subtotalsHeight: ninjaSubtotal.length * 16 + 16,
    subtotalsWithoutBalance: invoice.is_statement ? [[]] : ninjaSubtotal,
    subtotalsBalance: NINJA.subtotalsBalance(invoice),
    subtotalsBalanceInWords: NINJA.subtotalsBalanceInWords(invoice),
    balanceDue: formatMoneyInvoice(invoice.balance_amount, invoice),
    invoiceFooter: NINJA.invoiceFooter(invoice),
    invoiceNumber: invoice.invoice_number || " ",
    entityType: invoice.is_statement
      ? invoiceLabels.statement
      : invoice.is_quote
      ? invoiceLabels.quote
      : invoice.balance_amount < 0
      ? invoiceLabels.credit_note
      : invoiceLabels.invoice,
    entityTypeUC: (invoice.is_statement
      ? invoiceLabels.statement
      : invoice.is_quote
      ? invoiceLabels.quote
      : invoice.balance_amount < 0
      ? invoiceLabels.credit_note
      : invoiceLabels.invoice
    ).toUpperCase(),
    entityTaxType: invoice.is_statement
      ? invoiceLabels.statement
      : invoice.is_quote
      ? invoiceLabels.tax_quote
      : invoiceLabels.tax_invoice,
    fontSize: NINJA.fontSize,
    fontSizeLarger: NINJA.fontSize + 1,
    fontSizeLargest: NINJA.fontSize + 2,
    fontSizeSmaller: NINJA.fontSize - 1,
    bodyFont: NINJA.bodyFont,
    headerFont: NINJA.headerFont,
    forCompanyName: "For " + invoice.account.name,
    invoiceType: invoice.invoice_type ? invoice.invoice_type : "",
    subtotalsBalanceDue: NINJA.subtotalsBalanceDue(invoice),
    invoiceTitle: invoice.is_dc
      ? "Delivery Challan"
      : invoice.is_debit_note
      ? "DEBIT NOTE"
      : invoice.is_quote
      ? "Quotation"
      : invoice.is_statement
      ? "Statement"
      : invoice.is_po
      ? "Purchase"
      : invoice.is_pi
      ? "Proforma Invoice"
      : "TAX INVOICE",
    companyName: invoice.account.name,
    taxableAmount: NINJA.taxableAmount(invoice),
    panNo: invoice && invoice.client.id_number ? invoice.client.id_number : "",
    companyPanNo:
      invoice.account && invoice.account ? invoice.account.id_number : "",
    companyPhoneNo:
      invoice.account && invoice.account ? invoice.account.work_phone : "",
    companyGSTNO:
      invoice.account && invoice.account ? invoice.account.vat_number : "",
    poNumber: invoice.account && invoice.account ? invoice.po_number + "" : "",
    stateAndCode: companyStateAndCode(invoice),
    placeOfSupply: placeOfSupplyStateName(invoice),
    billingAddress: billingAddress(invoice),
    clientState: clientState(invoice),
    clientGSTNo: invoice.client ? invoice.client.vat_number + "" : "",
    clientPanNo: invoice.client ? invoice.client.id_number + "" : "",
    clientName: invoice.client ? invoice.client.name + "" : "",
    paidAmount: NINJA.paidAmount(invoice),
    taxlines: NINJA.taxlines(invoice),
    taxLineItemColumns: NINJA.taxColumns(invoice),
    createdAt: formatUtcToLocal(invoice.created_at),
    totalDiscount: 0,
    deliveryToLabel:
      invoice.deliveryaddress && invoice.deliveryaddress.public_id
        ? "Delivery Address"
        : "",
    paymentsInfo: NINJA.paymentInfo(invoice),
    amountWithoutDiscount: "Total Amount: " + formatMoneyInvoice(invoice.subtotal_amount, invoice),
  };

  var account = invoice.account;
  if (invoice.features.invoice_settings && account.invoice_fields) {
    var fields = JSON.parse(account.invoice_fields).invoice_fields;
  } else {
    var fields = [
      "invoice.invoice_type",
      "invoice.invoice_number",
      "invoice.po_number",
      "invoice.invoice_date",
      "invoice.due_date",
      "invoice.balance_due",
      "invoice.partial_due",
      "invoice.custom_text_value1",
      "invoice.custom_text_value2",
      "invoice.inextra_1",
      "invoice.inextra_2",
      "invoice.inextra_3",
      "invoice.inextra_4",
      "invoice.inextra_5",
      "invoice.inextra_6",
      "invoice.inextra_7",
      "invoice.inextra_8",
    ];
  }

  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var value = NINJA.renderField(invoice, field, true);
    if (value) {
      json[field] = value;
    }
  }

  for (var key in json) {
    // remove trailing commas for these fields
    if (["quantityWidth", "taxWidth"].indexOf(key) >= 0) {
      var regExp = new RegExp('"\\$' + key + '",', "g");
      val = json[key];
    } else {
      var regExp = new RegExp('"\\$' + key + '"', "g");
      var val = JSON.stringify(json[key]);
      val = doubleDollarSign(val);
    }
    javascript = javascript.replace(regExp, val);
  }

  // search/replace labels
  var regExp = new RegExp('"\\$\\w*?Label(UC)?(:)?(\\?)?"', "g");
  var matches = javascript.match(regExp);

  if (matches) {
    for (var i = 0; i < matches.length; i++) {
      var match = matches[i];
      field = match.substring(2, match.indexOf("Label"));
      field = toSnakeCase(field);
      var value = getDescendantProp(invoice, field);
      if (match.indexOf("?") < 0 || value) {
        if (invoice.partial > 0 && field == "balance_due") {
          field = "partial_due";
        } else if (invoice.is_quote) {
          if (field == "due_date") {
            field = "valid_until";
          } else {
            field = field.replace("invoice", "quote");
          }
        }
        if (invoice.is_statement) {
          if (field == "your_invoice") {
            field = "your_statement";
          } else if (field == "invoice_issued_to") {
            field = "statement_issued_to";
          } else if (field == "invoice_to") {
            field = "statement_to";
          }
        } else if (invoice.is_po) {
          if (field == "your_invoice") {
            field = "your_purchase";
          } else if (field == "invoice_issued_to") {
            field = "purchase_issued_from";
          } else if (field == "invoice_to") {
            field = "purchase_from";
          }
        } else if (invoice.is_debit_note) {
          if (field == "your_invoice") {
            field = "your_debit_note";
          } else if (field == "invoice_issued_to") {
            field = "debit_note_issued_to";
          } else if (field == "invoice_to") {
            field = "debit_note_to";
          }
        } else if (invoice.balance_amount < 0) {
          if (field == "your_invoice") {
            field = "your_credit";
          } else if (field == "invoice_issued_to") {
            field = "credit_issued_to";
          } else if (field == "invoice_to") {
            field = "credit_to";
          }
        }

        if (invoice.is_dc) {
          if (field == "your_invoice") {
            field = "your_delivery_challan";
          } else if (field == "invoice_issued_to") {
            field = "delivery_challan_issued_to";
          } else if (field == "invoice_to") {
            field = "credit_to";
          }
        }

        var label = invoiceLabels[field];
        if (match.indexOf("UC") >= 0) {
          label = label.toUpperCase();
        }
        if (match.indexOf(":") >= 0) {
          label = label + ":";
        }
      } else {
        label = " ";
      }
      javascript = javascript.replace(match, '"' + label + '"');
    }
  }

  // search/replace values
  var regExp = new RegExp('"\\$[a-z][\\w\\.]*?[Value]?"', "g");
  var matches = javascript.match(regExp);

  if (matches) {
    for (var i = 0; i < matches.length; i++) {
      var match = matches[i];

      // reserved words
      if (
        [
          '"$none"',
          '"$firstAndLast"',
          '"$notFirstAndLastColumn"',
          '"$notFirst"',
          '"$amount"',
          '"$primaryColor"',
          '"$secondaryColor"',
        ].indexOf(match) >= 0
      ) {
        continue;
      }

      // legacy style had 'Value' at the end
      if (endsWith(match, 'Value"')) {
        field = match.substring(2, match.indexOf("Value"));
      } else {
        field = match.substring(2, match.length - 1);
      }
      field = toSnakeCase(field);

      var value = getDescendantProp(invoice, field) || " ";
      value = doubleDollarSign(value);
      value = value.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
      javascript = javascript.replace(match, '"' + value + '"');
    }
  }

  return javascript;
};

function billingAddress(invoice) {
  var address;

  if (invoice.client) {
    var countryName = invoice.client.country ? invoice.client.country.name : "";
    address =
      invoice.client.address1 +
      invoice.client.address2 +
      invoice.client.statename +
      ", " +
      countryName;
  } else {
    address = "";
  }

  return address;
}

function formatUtcToLocal(utcDate) {
  utcDateObject = moment.utc(utcDate);
  return utcDateObject.tz("Asia/Kolkata").format("hh:mm:ss a");
}

function clientState(invoice) {
  if (invoice.client) {
    var state = states.filter(function (state) {
      if (state.id == invoice.client.state) {
        return state;
      }
    });

    if (state && state.length > 0) {
      state = state[0];
      return state.full_name + "-" + state.state_code;
    } else {
      return "";
    }
  }
}

function companyStateAndCode(invoice) {
  var state = states.filter(function (state) {
    if (state.id == invoice.account.state) {
      return state;
    }
  });

  if (state && state.length > 0) {
    state = state[0];
    return state.full_name + "-" + state.state_code;
  } else {
    return "";
  }
}

function placeOfSupplyStateName(invoice) {
  var state = states.filter(function (state) {
    if (state.id == invoice.state_of_supply) {
      return state;
    }
  });

  if (state && state.length > 0) {
    state = state[0];
    return state.full_name + "-" + state.state_code;
  } else {
    return "";
  }
}

NINJA.notesAndTerms = function (invoice) {
  var data = [];

  if (invoice.public_notes) {
    data.push({
      stack: [
        {
          text: invoice.is_recurring
            ? processVariables(invoice.public_notes)
            : invoice.public_notes,
          style: ["notes"],
        },
      ],
    });
    data.push({ text: " " });
  }

  if (invoice.terms) {
    data.push({ text: invoiceLabels.terms, style: ["termsLabel"] });
    data.push({
      stack: [
        {
          text: invoice.is_recurring
            ? processVariables(invoice.terms)
            : invoice.terms,
          style: ["terms"],
        },
      ],
    });
  }

  return NINJA.prepareDataList(data, "notesAndTerms");
};

NINJA.statementColumns = function (invoice) {
  return ["15%", "25%", "10%", "10%", "15%", "25%"];
};

NINJA.statementLines = function (invoice) {
  var grid = [[]];
  grid[0].push({
    text: "Transaction",
    style: ["tableHeader", "itemTableHeader"],
  });
  grid[0].push({ text: "Ref No", style: ["tableHeader", "itemTableHeader"] });
  grid[0].push({
    text: "Date",
    style: ["tableHeader", "invoiceDateTableHeader"],
  });
  //grid[0].push({text: "Due Date", style: ['tableHeader', 'dueDateTableHeader']});
  grid[0].push({
    text: invoiceLabels.total,
    style: ["tableHeader", "totalTableHeader"],
  });
  grid[0].push({
    text: invoiceLabels.balance,
    style: ["tableHeader", "balanceTableHeader"],
  });
  grid[0].push({ text: "Extra", style: ["tableHeader", "itemTableHeader"] });

  var statement = [];

  for (var i = 0; i < invoice.invoice_items.length; i++) {
    var item = invoice.invoice_items[i];
    var extra = JSON.parse(item.private_notes);
    var extraInfo = " ";

    for (p in extra) {
      extraInfo += invoiceLabels[p] + ": " + extra[p] + "\n";
    }

    statement.push({
      type: item.invoice_type_id == 4 ? "Debit Note" : item.invoice_type_id == 3 ? "Purchase"  : "Invoice",
      no: item.invoice_number,
      date: item.invoice_date,
      due_date: item.invoice_date,
      amount: item.amount,
      balance: item.balance,
      extra: extraInfo,
    });
  }

  for (var i = 0; i < invoice.payments.length; i++) {
    var item = invoice.payments[i];

    var description = "";

    if (item.invoice) {
      description =
        "For " +
        (item.invoice.invoice_type_id == 4 ? "Debit Note" : "Invoice") +
        ": " +
        item.invoice.invoice_number;
    } else {
      description = "Payment Received";
    }

    statement.push({
      type: "Payment",
      no: description,
      date: item.payment_date,
      due_date: "-",
      amount: item.amount,
      balance: "-",
      extra: " ",
    });
  }

  var statement = statement.sort(function (a, b) {
    var dateA = new Date(a.date).getTime();
    var dateB = new Date(b.date).getTime();
    return dateA > dateB ? 1 : -1;
  });

  for (var i = 0; i < statement.length; i++) {
    var item = statement[i];
    var row = [];
    var rowStyle = i % 2 == 0 ? "odd" : "even";
    grid.push([
      { text: item.type, style: ["invoiceNumber", "productKey", rowStyle] },
      { text: item.no, style: ["invoiceNumber", "productKey", rowStyle] },
      {
        text:
          item.date && item.date != "0000-00-00"
            ? moment(item.date).format(invoice.date_format)
            : " ",
        style: ["invoiceDate", rowStyle],
      },
      //{text: (item.due_date == '-')?' ':item.due_date && item.due_date != '0000-00-00' ? moment(item.due_date).format(invoice.date_format) : ' ', style:['dueDate', rowStyle]},
      {
        text: formatMoneyInvoice(item.amount, invoice),
        style: ["subtotals", rowStyle],
      },
      {
        text:
          item.balance == "-" ? " " : formatMoneyInvoice(item.balance, invoice),
        style: ["lineTotal", rowStyle],
      },
      { text: item.extra, style: ["invoiceNumber", rowStyle] },
    ]);
  }

  // for (var i = 0; i < invoice.invoice_items.length; i++) {
  //     var item = invoice.invoice_items[i];
  //     var row = [];
  //     var rowStyle = (i % 2 == 0) ? 'odd' : 'even';
  //     grid.push([
  //         {text: "Invoice",style:['invoiceNumber', 'productKey', rowStyle]},
  //         {text: item.invoice_number, style:['invoiceNumber', 'productKey', rowStyle]},
  //         {text: item.invoice_date && item.invoice_date != '0000-00-00' ? moment(item.invoice_date).format(invoice.date_format) : ' ', style:['invoiceDate', rowStyle]},
  //         {text: item.due_date && item.due_date != '0000-00-00' ? moment(item.due_date).format(invoice.date_format) : ' ', style:['dueDate', rowStyle]},
  //         {text: formatMoneyInvoice(item.amount, invoice), style:['subtotals', rowStyle]},
  //         {text: formatMoneyInvoice(item.balance, invoice), style:['lineTotal', rowStyle]},
  //     ]);
  // }

  // for (var i = 0; i < invoice.payments.length; i++) {
  //     var item = invoice.payments[i];
  //     var row = [];
  //     var rowStyle = (i % 2 == 0) ? 'odd' : 'even';
  //     grid.push([
  //         {text: "Payment",style:['invoiceNumber', 'productKey', rowStyle]},
  //         {text: item.id+"" , style:['invoiceNumber', 'productKey', rowStyle]},
  //         {text: item.payment_date && item.payment_date != '0000-00-00' ? moment(item.payment_date).format(invoice.date_format) : ' ', style:['invoiceDate', rowStyle]},
  //         {text: ' ', style:['dueDate', rowStyle]},
  //         {text: formatMoneyInvoice(item.amount, invoice), style:['subtotals', rowStyle]},
  //         {text: ' ', style:['lineTotal', rowStyle]},
  //     ]);
  // }

  return NINJA.prepareDataTable(grid, "invoiceItems");
};

NINJA.taxColumns = function (invoice) {
  var column = [];

  column.push("20%");
  column.push("20%");
  column.push("15%");
  column.push("15%");
  column.push("15%");
  column.push("15%");

  return column;
};

NINJA.invoiceColumns = function (invoice) {
  var account = invoice.account;

  var columnWidth = null;

  if (invoice.features.invoice_settings) {
    if (invoice.client && invoice.client.product_fields) {
      var fields = JSON.parse(invoice.client.product_fields).product_fields;
      if (invoice.client.product_fields_width) {
        columnWidth = invoice.client.product_fields_width.split(",");
      }
    } else if (account.invoice_fields) {
      var fields = JSON.parse(account.invoice_fields).product_fields;
      if (account.column_widths) {
        columnWidth = account.column_widths.split(",");
      }
    }
  } else {
    var fields = [
      "product.product_key",
      "product.hsncode",
      "product.description",
      "product.cost",
      "product.quantity",
      "product.taxable_amount",
      "product.tax",
      "product.line_total",
    ];
  }

  if (!fields) {
    var fields = [
      "product.product_key",
      "product.hsncode",
      "product.description",
      "product.cost",
      "product.quantity",
      "product.taxable_amount",
      "product.tax",
      "product.line_total",
    ];
  }

  var account = invoice.account;
  var columns = [];

  $.each(fields, function (index, data) {
    if (
      invoice.is_dc == true &&
      (data == "product.taxable_amount" ||
        data == "product.tax" ||
        data == "product.cess")
    ) {
      return;
    }

    if (columnWidth && columnWidth[index]) {
      if (columnWidth[index] == "*") {
        columns.push("*");
      } else {
        columns.push(columnWidth[index] + "%");
      }
    } else {
      if (invoice.has_product_key && data === "product.product_key") {
        if (fields.indexOf("product.description") == -1) {
          columns.push("*");
        } else {
          columns.push("15%");
        }
      }
      if (data == "product.sr_no") {
        columns.push("5%");
      }

      if (data === "product.hsncode") {
        columns.push("10%");
      }

      if (data === "product.description") {
        columns.push("*");
      }

      if (
        invoice.features.invoice_settings &&
        account.custom_invoice_item_label1 &&
        data === "product.custom_value1"
      ) {
        columns.push("7%");
      }
      if (
        invoice.features.invoice_settings &&
        account.custom_invoice_item_label2 &&
        data === "product.custom_value2"
      ) {
        columns.push("7%");
      }

      if (data === "product.cost") {
        columns.push("13%");
      }

      if (account.hide_quantity != "1" && data === "product.quantity") {
        columns.push("7%");
      }

      if (data == "product.extra_1") {
        columns.push("7%");
      }
      if (data == "product.extra_2") {
        columns.push("7%");
      }
      if (data == "product.extra_3") {
        columns.push("7%");
      }
      if (data == "product.extra_4") {
        columns.push("7%");
      }
      if (data == "product.extra_5") {
        columns.push("7%");
      }
      if (data == "product.extra_6") {
        columns.push("7%");
      }
      if (data == "product.extra_7") {
        columns.push("7%");
      }
      if (data == "product.extra_8") {
        columns.push("7%");
      }

      if (data == "cess") {
        columns.push("7%");
      }

      if (data == "product.mrp") {
        columns.push("7%");
      }
      if (data == "product.discount") {
        columns.push("7%");
      }

      if (data === "product.taxable_amount") {
        columns.push("9%");
      }

      if (account.show_item_taxes == "1" && data === "product.tax") {
        columns.push("10%");
      }

      if (data === "product.line_total") {
        columns.push("13%");
      }
    }
  });

  return columns;
};

NINJA.invoiceFooter = function (invoice) {
  var footer = invoice.invoice_footer;

  if (invoice.is_recurring) {
    footer = processVariables(footer);
  }

  if (!invoice.features.invoice_settings && invoice.invoice_design_id == 3) {
    return footer ? footer.substring(0, 200) : " ";
  } else {
    return footer || " ";
  }
};

NINJA.quantityWidth = function (invoice) {
  return invoice.account.hide_quantity == "1" ? "" : '"14%", ';
};

NINJA.taxWidth = function (invoice) {
  return invoice.account.show_item_taxes == "1" ? '"14%", ' : "";
};

NINJA.taxlines = function (invoice) {
  var grid = [[]];

  var account = invoice.account;

  if (invoice.is_statement == true) {
    grid[0].push({ text: " ", style: [] });
    grid[0].push({ text: " ", style: [] });
    grid[0].push({ text: " ", style: [] });
    grid[0].push({ text: " ", style: [] });
    grid[0].push({ text: " ", style: [] });
    grid[0].push({ text: " ", style: [] });
  } else {
    var taxes = [];
    var cesses = [];

    for (var i = 0; i < invoice.invoice_items.length; i++) {
      var item = invoice.invoice_items[i];

      if (!invoice.invoice_items[i].product_key) {
        continue;
      }

      if (
        cesses.includes(item.cess_precentage) == false &&
        parseFloat(item.cess_precentage) > 0
      ) {
        cesses.push(item.cess_precentage);
      }

      if (taxes.includes(parseFloat(item.tax_rate2)) == false) {
        taxes.push(parseFloat(item.tax_rate2));
      }
    }

    grid[0].push({ text: "Tax Name", style: ["taxTableHeader"] });
    grid[0].push({ text: "Amount", style: ["taxTableHeader"] });

    if (account.show_tax_rate_in_tax_table == true) {
      grid[0].push({ text: "SGST", style: ["taxTableHeader"], colSpan: 2 }, {});
      grid[0].push({ text: "CGST", style: ["taxTableHeader"], colSpan: 2 }, {});
      grid[0].push({ text: "IGST", style: ["taxTableHeader"], colSpan: 2 }, {});
      grid[0].push({ text: "CESS", style: ["taxTableHeader"], colSpan: 2 }, {});
    } else {
      grid[0].push({ text: "SGST", style: ["taxTableHeader"] });
      grid[0].push({ text: "CGST", style: ["taxTableHeader"] });
      grid[0].push({ text: "IGST", style: ["taxTableHeader"] });
      grid[0].push({ text: "CESS", style: ["taxTableHeader"] });
    }

    var subHeader = [];

    subHeader.push({ text: " ", style: ["taxTableHeader"] });
    subHeader.push({ text: " ", style: ["taxTableHeader"] });
    if (account.show_tax_rate_in_tax_table == true) {
      subHeader.push({ text: "Rate", style: ["taxTableHeader"] });
    }
    subHeader.push({ text: "Amt.", style: ["taxTableHeader"] });
    if (account.show_tax_rate_in_tax_table == true) {
      subHeader.push({ text: "Rate", style: ["taxTableHeader"] });
    }
    subHeader.push({ text: "Amt.", style: ["taxTableHeader"] });
    if (account.show_tax_rate_in_tax_table == true) {
      subHeader.push({ text: "Rate", style: ["taxTableHeader"] });
    }
    subHeader.push({ text: "Amt.", style: ["taxTableHeader"] });
    if (account.show_tax_rate_in_tax_table == true) {
      subHeader.push({ text: "Rate", style: ["taxTableHeader"] });
    }
    subHeader.push({ text: "Amt.", style: ["taxTableHeader"] });

    grid.push(subHeader);

    for (var i = 0; i < taxes.length; i++) {
      var sgst = 0;
      var cgst = 0;
      var igst = 0;
      var taxableAmount = 0;

      var filteredProducts = _.map(invoice.invoice_items, function (o) {
        if (parseFloat(o.tax_rate2) == parseFloat(taxes[i])) return o;
      });

      for (var j = 0; j < filteredProducts.length; j++) {
        if (typeof filteredProducts[j] == "undefined") {
          continue;
        }

        sgst += parseFloat(filteredProducts[j].tax1_amount);
        cgst += parseFloat(filteredProducts[j].tax2_amount);
        igst += parseFloat(filteredProducts[j].tax3_amount);
        taxableAmount += parseFloat(filteredProducts[j].taxable_amount);
      }

      var row = [];

      row.push({
        text: "GST " + parseFloat(taxes[i]) * 2 + "%",
        style: ["taxTableRow"],
      });
      row.push({
        text: taxableAmount.toFixed(2) + "" || " ",
        style: ["taxTableRow"],
      });
      if (account.show_tax_rate_in_tax_table == true) {
        row.push({
          text: sgst && sgst > 0 ? taxes[i] + "%" : "-",
          style: ["taxTableRow"],
        });
      }
      row.push({
        text: sgst && sgst > 0 ? sgst.toFixed(2) + "" : "-",
        style: ["taxTableRow"],
      });
      if (account.show_tax_rate_in_tax_table == true) {
        row.push({
          text: cgst && cgst > 0 ? taxes[i] + "%" : "-",
          style: ["taxTableRow"],
        });
      }
      row.push({
        text: cgst && cgst > 0 ? cgst.toFixed(2) + "" : "-",
        style: ["taxTableRow"],
      });
      if (account.show_tax_rate_in_tax_table == true) {
        row.push({
          text: igst && igst > 0 ? parseFloat(taxes[i]) * 2 + "%" : "-",
          style: ["taxTableRow"],
        });
      }
      row.push({
        text: igst && igst > 0 ? igst.toFixed(2) + "" : "-",
        style: ["taxTableRow"],
      });
      if (account.show_tax_rate_in_tax_table == true) {
        row.push({ text: "-", style: ["taxTableRow"] });
      }
      row.push({ text: "-", style: ["taxTableRow"] });

      grid.push(row);
    }

    for (var i = 0; i < cesses.length; i++) {
      var cess = 0;
      var taxableAmount = 0;

      var filteredProducts = _.map(invoice.invoice_items, function (o) {
        if (o.cess_precentage == cesses[i]) return o;
      });

      for (var j = 0; j < filteredProducts.length; j++) {
        if (typeof filteredProducts[j] == "undefined") {
          continue;
        }

        taxableAmount += parseFloat(filteredProducts[j].taxable_amount);
        cess += parseFloat(filteredProducts[j].raw_cess_amount);
      }

      var row = [];

      row.push({ text: "CESS " + cesses[i] + "%" });
      row.push({ text: taxableAmount.toFixed(2) + "" || "-" });
      row.push({ text: "-" });
      row.push({ text: "-" });
      row.push({ text: "-" });
      row.push({ text: cess ? cess.toFixed(2) + "" : "-" });

      grid.push(row);
    }
  }

  return grid;
};

NINJA.paymentInfo = function (invoice) {
  if (invoice.payments != null) {
    var paymentInfo = "";
    invoice.payments.forEach((payment, index) => {
      paymentInfo +=
        "Payment Amount: " +
        payment.amount +
        ". Payment Mode: " +
        (payment.payment_type ? payment.payment_type.name : "Default") +
        "\n";
    });
    return paymentInfo;
  } else {
    return "";
  }
};

NINJA.invoiceLines = function (invoice, isSecondTable) {
  var account = invoice.account;
  var total = 0;
  var shownItem = false;
  var hideQuantity = invoice.account.hide_quantity == "1";
  var showItemTaxes = invoice.account.show_item_taxes == "1";
  var isTasks = isSecondTable || (invoice.hasTasks && !invoice.hasStandard);

  if (invoice.features.invoice_settings && account.invoice_fields) {
    if (invoice.client && invoice.client.product_fields) {
      var fields = JSON.parse(invoice.client.product_fields).product_fields;
    } else if (account.invoice_fields) {
      var fields = JSON.parse(account.invoice_fields).product_fields;
    }
  } else {
    var fields = [
      "product.sr_no",
      "product.product_key",
      "product.hsncode",
      "product.description",
      "product.cost",
      "product.quantity",
      "product.taxable_amount",
      "product.tax",
      "product.line_total",
    ];
  }

  var grid = [[]];
  var styles = ["tableHeader"];
  if (isSecondTable) {
    styles.push("secondTableHeader");
  }

  $.each(fields, function (key, data) {
    if (
      invoice.is_dc == true &&
      (data == "product.taxable_amount" ||
        data == "product.tax" ||
        data == "product.cess" ||
        data.includes("extra"))
    ) {
      return;
    }

    if (data === "product.sr_no") {
      grid[0].push({
        text: "Sr No",
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (invoice.has_product_key && data === "product.product_key") {
      grid[0].push({
        text: isTasks ? invoiceLabels.service : invoiceLabels.item,
        style: styles.concat("itemTableHeader"),
      });
    } else if (data === "product.hsncode") {
      grid[0].push({
        text: "HSN/SAC",
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data === "product.description") {
      grid[0].push({
        text: invoiceLabels.description,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_1") {
      grid[0].push({
        text: invoiceLabels.extra_1,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_2") {
      grid[0].push({
        text: invoiceLabels.extra_2,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_3") {
      grid[0].push({
        text: invoiceLabels.extra_3,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_4") {
      grid[0].push({
        text: invoiceLabels.extra_4,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (
      invoice.account.app_type != "SECURITY_APP" &&
      data == "product.extra_5"
    ) {
      grid[0].push({
        text: invoiceLabels.extra_5,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_6") {
      grid[0].push({
        text: invoiceLabels.extra_6,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_7") {
      grid[0].push({
        text: invoiceLabels.extra_7,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.extra_8") {
      grid[0].push({
        text: invoiceLabels.extra_8,
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (data == "product.cess") {
      grid[0].push({
        text: "Cess",
        style: styles.concat("descriptionTableHeader"),
      });
    } else if (
      invoice.features.invoice_settings &&
      account.custom_invoice_item_label1 &&
      data === "product.custom_value1"
    ) {
      grid[0].push({
        text: account.custom_invoice_item_label1,
        style: styles.concat("custom1TableHeader"),
      });
    } else if (
      invoice.features.invoice_settings &&
      account.custom_invoice_item_label2 &&
      data === "product.custom_value2"
    ) {
      grid[0].push({
        text: account.custom_invoice_item_label2,
        style: styles.concat("custom2TableHeader"),
      });
    } else if (
      !hideQuantity &&
      (data === "product.cost" || data === "product.quantity")
    ) {
      if (data === "product.cost") {
        grid[0].push({
          text: isTasks ? invoiceLabels.rate : invoiceLabels.unit_cost,
          style: styles.concat("costTableHeader"),
        });
      }
      if (data === "product.quantity") {
        grid[0].push({
          text: isTasks ? invoiceLabels.hours : invoiceLabels.quantity,
          style: styles.concat("qtyTableHeader"),
        });
      }
    } else if (data == "product.mrp") {
      grid[0].push({
        text: isTasks ? invoiceLabels.hours : invoiceLabels.mrp,
        style: styles.concat("qtyTableHeader"),
      });
    } else if (data == "product.discount") {
      grid[0].push({
        text: isTasks ? invoiceLabels.hours : invoiceLabels.discount,
        style: styles.concat("qtyTableHeader"),
      });
    } else if (data === "product.taxable_amount") {
      grid[0].push({
        text: invoiceLabels.taxable_amount,
        style: styles.concat("custom2TableHeader"),
      });
    } else if (showItemTaxes && data === "product.tax") {
      grid[0].push({
        text: invoiceLabels.tax,
        style: styles.concat("taxTableHeader"),
      });
    } else if (data === "product.line_total") {
      grid[0].push({
        text: invoiceLabels.line_total,
        style: styles.concat("lineTotalTableHeader"),
      });
    }
  });

  var projectSites = [];

  for (var i = 0; i < invoice.invoice_items.length; i++) {
    var address = invoice.invoice_items[i].project_site_address;
    var projectId = invoice.invoice_items[i].project_id;

    if (projectId && !(projectId in projectSites)) {
      projectSites[projectId] = address;
    }
  }

  var totalBoxes = 0;
  var totalLoose = 0;
  var noOfRows = 0;

  if (account.project_enabled && projectSites.length > 0) {
    projectSites.forEach(function (value, key) {
      var invoiceItems = invoice.invoice_items.filter(function (invoiceItem) {
        return invoiceItem.project_id == key;
      });

      var rowAdded = false;
      var totalTaxableAmount = 0;
      var totalSGST = 0;
      var totalCGST = 0;
      var totalIGST = 0;
      var grandTotal = 0;

      if (invoiceItems.length > 0 && value) {
        //Site address
        var siteAddRow = [];
        siteAddRow.push({ text: "Site Address ", style: ["odd"] });
        siteAddRow.push({ text: value + " ", style: ["odd"] });
        for (var j = 0; j < fields.length - 2; j++) {
          siteAddRow.push({ text: " ", style: ["odd"] });
        }
        grid.push(siteAddRow);
      }

      for (var i = 0; i < invoiceItems.length; i++) {
        var item = invoiceItems[i];

        var row = generateInvoiceItemRow(
          fields,
          invoice,
          item,
          isTasks,
          showItemTaxes,
          grid,
          hideQuantity,
          i
        );

        var taxableAmount = parseFloat(
          item.item_taxable_amount ? item.item_taxable_amount : 0
        );
        totalTaxableAmount += taxableAmount;
        totalSGST += item.tax1_amount;
        totalCGST += item.tax2_amount;
        totalIGST += item.tax3_amount;
        grandTotal +=
          taxableAmount +
          item.tax1_amount +
          item.tax2_amount +
          item.tax3_amount;

        if (row != -1) {
          rowAdded = true;
          grid.push(row);
        }
      }

      if (rowAdded) {
        row = [];
        for (var j = 0; j < fields.length - 2; j++) {
          row.push({ text: " ", style: ["odd"] });
        }
        row.push({ text: "Total", style: ["odd"] });
        row.push({ text: grandTotal.toFixed(2) + "", style: ["subtotals"] });
        grid.push(row);

        // if(totalSGST > 0){
        //     row = [];
        //     for(var j = 0;j<fields.length-2;j++){
        //         row.push({text:' ' ,style: ['odd']});
        //     }
        //     row.push({text:'SGST@9%' ,style: ['odd']});
        //     row.push({text:totalSGST.toFixed(2)+"" ,style: ['subtotals']});
        //     grid.push(row);
        // }

        // if(totalCGST > 0){
        //     row = [];
        //     for(var j = 0;j<fields.length-2;j++){
        //         row.push({text:' ' ,style: ['odd']});
        //     }
        //     row.push({text:'CGST@9%' ,style: ['odd']});
        //     row.push({text:totalCGST.toFixed(2)+"" ,style: ['subtotals']});
        //     grid.push(row);
        // }

        // if(totalIGST > 0){
        //     row = [];
        //     for(var j = 0;j<fields.length-2;j++){
        //         row.push({text:' ' ,style: ['odd']});
        //     }
        //     row.push({text:'IGST' ,style: ['odd']});
        //     row.push({text:totalIGST.toFixed(2)+"" ,style: ['subtotals']});
        //     grid.push(row);
        // }

        // row = [];
        // for(var j = 0;j<fields.length-2;j++){
        //     row.push({text:' ' ,style: ['odd']});
        // }
        // row.push({text:'Grand Total' ,style: ['odd']});
        // row.push({text:grandTotal.toFixed(2)+"" ,style: ['subtotals']});
        // grid.push(row);
      }
    });
  } else {
    for (var i = 0; i < invoice.invoice_items.length; i++) {
      var item = invoice.invoice_items[i];
      var raw = generateInvoiceItemRow(
        fields,
        invoice,
        item,
        isTasks,
        showItemTaxes,
        grid,
        hideQuantity,
        i
      );

      if (
        item.catron_quantity &&
        item.carton_unit &&
        item.qty / item.catron_quantity >= 1
      ) {
        totalBoxes += Math.floor(item.qty / item.catron_quantity);
        totalLoose += item.qty % item.catron_quantity;
      } else {
        totalLoose += item.qty;
      }

      if (raw != -1) {
        noOfRows++;
        grid.push(raw);
      }
    }
  }

  var minimumRowsToShow = account.mininum_product_rows;

  if (minimumRowsToShow != null && noOfRows < minimumRowsToShow) {
    var blankRow = createBlankRow(fields, invoice, totalBoxes, totalLoose);
    for (i = 0; i < minimumRowsToShow - noOfRows; i++) {
      grid.push(blankRow);
    }
  }

  if (account.show_items_total) {
    var totalQtyRow = createTotalQuantityRow(
      fields,
      invoice,
      totalBoxes,
      totalLoose
    );
    grid.push(totalQtyRow);
  }

  return NINJA.prepareDataTable(grid, "invoiceItems");
};

function generateInvoiceItemRow(
  fields,
  invoice,
  item,
  isTasks,
  showItemTaxes,
  grid,
  hideQuantity,
  srno
) {
  var row = [];
  var cost = parseFloat(item.cost ? item.cost.toString() : 0);
  var qty = NINJA.parseFloat(item.qty)
    ? roundToTwo(NINJA.parseFloat(item.qty)) + ""
    : "";
  var taxable = parseFloat(
    item.item_taxable_amount ? item.item_taxable_amount : 0
  );

  var productKey = item.product_key;
  var tax1 = "";
  var tax2 = "";
  var custom_value1 = item.custom_value1 ? parseFloat(item.custom_value1) : 0;
  var custom_value2 = item.custom_value2 ? parseFloat(item.custom_value2) : 0;
  var taxline = item.rpt_item_tax ? item.rpt_item_tax : 0.0;
  var cessline = item.rpt_item_cess ? item.rpt_item_cess : 0.0;
  var hsnCode = item.HSNCode;

  var description = new Object();
  var notes = " ";

  var discount = parseFloat(item.discount_amount).toFixed(2);

  if (discount == 0) {
    discount = " ";
  } else {
    if (item.is_amount_discount == false) {
      discount += "%";
    }
  }

  if (IsJsonString(item.notes)) {
    description = JSON.parse(item.notes);
    notes = description.note;
  } else {
    notes = item.notes;
  }

  if (isTasks) {
    if (item.invoice_item_type_id != 2) {
      return -1;
    }
  } else {
    if (item.invoice_item_type_id == 2) {
      return -1;
    }
  }

  if (showItemTaxes) {
    if (item.tax_name1) {
      tax1 = parseFloat(item.tax_rate1);
    }
    if (item.tax_name2) {
      tax2 = parseFloat(item.tax_rate2);
    }
  }

  // show at most one blank line
  if (
    !notes &&
    !productKey &&
    productKey != " " &&
    (!cost ||
      cost == "Rs. 0.00" ||
      cost == "0" ||
      cost == "0.00" ||
      cost == "0,00")
  ) {
    return -1;
  }

  var shownItem = true;

  // process date variables
  if (invoice.is_recurring) {
    notes = processVariables(notes);
    productKey = processVariables(productKey);
    custom_value1 = processVariables(item.custom_value1);
    custom_value2 = processVariables(item.custom_value2);
  }

  var lineTotal = item.item_total;

  rowStyle = grid.length % 2 == 0 ? "even" : "odd";

  $.each(fields, function (key, data) {
    if (
      invoice.is_dc == true &&
      (data == "product.taxable_amount" ||
        data == "product.tax" ||
        data == "product.cess" ||
        data.includes("extra"))
    ) {
      return;
    } else if (
      invoice.is_dc == true &&
      (data == "product.cost" || data == "product.line_total")
    ) {
      row.push({ text: " ", style: ["sr_no", rowStyle] });
      return row;
    }

    if (data === "product.sr_no") {
      row.push({ text: srno + " ", style: ["sr_no", rowStyle] });
    } else if (data == "product.extra_1") {
      row.push({
        text: description.extra_1 ? description.extra_1 : " ",
        style: [rowStyle],
      });
    } else if (data == "product.extra_2") {
      row.push({
        text: description.extra_2 ? description.extra_2 : " ",
        style: [rowStyle],
      });
    } else if (data == "product.extra_3") {
      row.push({
        text: description.extra_3 ? description.extra_3 : " ",
        style: [rowStyle],
      });
    } else if (data == "product.extra_4") {
      row.push({
        text: description.extra_4 ? description.extra_4 : " ",
        style: [rowStyle],
      });
    } else if (
      invoice.account.app_type != "SECURITY_APP" &&
      data == "product.extra_5"
    ) {
      row.push({
        text: description.extra_5 ? description.extra_5 : " ",
        style: [rowStyle],
      });
    } else if (data == "product.extra_6") {
      row.push({
        text: description.extra_6 ? description.extra_6 : " ",
        style: [rowStyle],
      });
    } else if (data == "product.extra_7") {
      row.push({
        text: description.extra_7 ? description.extra_7 : " ",
        style: [rowStyle],
      });
    } else if (data == "product.extra_8") {
      row.push({
        text: description.extra_8 ? description.extra_8 : " ",
        style: [rowStyle],
      });
    } else if (invoice.has_product_key && data === "product.product_key") {
      row.push({ style: ["productKey", rowStyle], text: productKey || " " }); // product key can be blank when selecting from a datalist
    } else if (data === "product.hsncode") {
      row.push({
        style: ["notes", rowStyle],
        stack: [{ text: hsnCode || " " }],
      });
    } else if (data === "product.description") {
      row.push({
        style: ["notes", rowStyle],
        stack: [{ text: item.description || " " }],
      });
    } else if (
      invoice.features.invoice_settings &&
      data === "product.custom_value1"
    ) {
      row.push({
        style: ["customValue1", rowStyle],
        text: custom_value1.toFixed(2) || " ",
      });
    } else if (
      invoice.features.invoice_settings &&
      data === "product.custom_value2"
    ) {
      row.push({
        style: ["customValue2", rowStyle],
        text: custom_value2.toFixed(2) || " ",
      });
    } else if (
      !hideQuantity &&
      (data === "product.cost" || data === "product.quantity")
    ) {
      if (data === "product.cost") {
        row.push({
          style: ["cost", rowStyle],
          text: cost ? cost.toFixed(2) : "0.00" || " ",
        });
      }

      if (data === "product.quantity") {
        var quantity = qty;

        if (invoice.account.app_type == "SECURITY_APP" && description.extra_5) {
          quantity = qty + " + " + description.extra_5 + " Hours";
        }

        if (
          item.catron_quantity &&
          item.carton_unit &&
          qty / item.catron_quantity >= 1
        ) {
          var quantity =
            item.carton_unit + ": " + Math.floor(qty / item.catron_quantity);

          var balance = qty % item.catron_quantity;
          if (balance > 0) {
            quantity += " Loose:" + balance;
          }

          quantity = qty + " (" + quantity + ")";
        }

        row.push({
          style: ["quantity", rowStyle],
          text: quantity + " " || " ",
        });
      }
    } else if (data === "product.taxable_amount") {
      row.push({
        style: ["cost", rowStyle],
        text: taxable ? taxable.toFixed(2) : "0.00" || " ",
      });
    } else if (showItemTaxes && data === "product.tax") {
      row.push({ style: ["tax", rowStyle], text: taxline || " " });
    } else if (showItemTaxes && data === "product.cess") {
      row.push({ style: ["tax", rowStyle], text: cessline || " " });
    } else if (data === "product.line_total") {
      var totalToShow = 0;
      if (lineTotal) {
        if (!isNaN(lineTotal)) {
          totalToShow = lineTotal.toFixed(2);
        } else {
          totalToShow = lineTotal;
        }
      } else {
        totalToShow = "0.00";
      }

      row.push({ style: ["lineTotal", rowStyle], text: totalToShow || " " });
    } else if (data == "product.mrp") {
      row.push({ style: ["lineTotal", rowStyle], text: item.mrp || " " });
    } else if (data == "product.discount") {
      row.push({
        style: ["lineTotal", rowStyle],
        text: discount ? discount : "-" || " ",
      });
    }
  });

  return row;
}

function createBlankRow(fields, invoice, totalBoxes, totalLoose) {
  var row = [];
  var account = invoice.account;
  var hideQuantity = invoice.account.hide_quantity == "1";
  var showItemTaxes = invoice.account.show_item_taxes == "1";
  var rowStyle = "odd";

  $.each(fields, function (key, data) {
    if (
      invoice.is_dc == true &&
      (data == "product.taxable_amount" ||
        data == "product.tax" ||
        data == "product.cess" ||
        data.includes("extra"))
    ) {
      return;
    } else if (
      invoice.is_dc == true &&
      (data == "product.cost" || data == "product.line_total")
    ) {
      row.push({ text: " ", style: ["sr_no", rowStyle] });
      return;
    }

    if (data === "product.sr_no") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_1") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_2") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_3") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_4") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (
      invoice.account.app_type != "SECURITY_APP" &&
      data == "product.extra_5"
    ) {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_6") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_7") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_8") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data === "product.product_key" && invoice.has_product_key) {
      row.push({ style: ["productKey", rowStyle], text: " " }); // product key can be blank when selecting from a datalist
    } else if (data === "product.hsncode") {
      row.push({ style: ["notes", rowStyle], stack: [{ text: " " }] });
    } else if (data === "product.description") {
      row.push({ style: ["notes", rowStyle], stack: [{ text: " " }] });
    } else if (
      account.custom_invoice_item_label1 &&
      data === "product.custom_value1"
    ) {
      row.push({ style: ["customValue1", rowStyle], text: " " });
    } else if (
      account.custom_invoice_item_label2 &&
      data === "product.custom_value2"
    ) {
      row.push({ style: ["customValue2", rowStyle], text: " " });
    } else if (
      !hideQuantity &&
      (data === "product.cost" || data === "product.quantity")
    ) {
      if (data === "product.cost") {
        row.push({ style: ["tableHeader", rowStyle], text: " " });
      }

      var totalQty = 0;

      try {
        totalQty = invoice.totalQuantity + " ";
        if (totalBoxes > 0) {
          totalQty += " Box:" + totalBoxes + " Loose:" + totalLoose;
        }
      } catch (err) {
        totalQty = 0;
      }

      if (data === "product.quantity") {
        row.push({ style: ["tableHeader", rowStyle], text: " " });
      }
    } else if (data === "product.taxable_amount") {
      row.push({ style: ["cost", rowStyle], text: " " });
    } else if (showItemTaxes && data === "product.tax") {
      row.push({ style: ["tax", rowStyle], text: " " });
    } else if (showItemTaxes && data === "product.cess") {
      row.push({ style: ["tax", rowStyle], text: " " });
    } else if (data === "product.line_total") {
      row.push({ style: ["lineTotal", rowStyle], text: " " });
    } else if (data == "product.mrp") {
      row.push({ style: ["lineTotal", rowStyle], text: " " });
    } else if (data == "product.discount") {
      row.push({ style: ["lineTotal", rowStyle], text: " " });
    }
  });

  return row;
}

function createTotalQuantityRow(fields, invoice, totalBoxes, totalLoose) {
  var row = [];
  var account = invoice.account;
  var hideQuantity = invoice.account.hide_quantity == "1";
  var showItemTaxes = invoice.account.show_item_taxes == "1";
  var rowStyle = "odd";

  $.each(fields, function (key, data) {
    if (
      invoice.is_dc == true &&
      (data == "product.taxable_amount" ||
        data == "product.tax" ||
        data == "product.cess" ||
        data.includes("extra"))
    ) {
      return;
    } else if (
      invoice.is_dc == true &&
      (data == "product.cost" || data == "product.line_total")
    ) {
      row.push({ text: " ", style: ["sr_no", rowStyle] });
      return row;
    }

    if (data === "product.sr_no") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_1") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_2") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_3") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_4") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (
      invoice.account.app_type != "SECURITY_APP" &&
      data == "product.extra_5"
    ) {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_6") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_7") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data == "product.extra_8") {
      row.push({ text: " ", style: [rowStyle] });
    } else if (data === "product.product_key" && invoice.has_product_key) {
      row.push({ style: ["productKey", rowStyle], text: " " }); // product key can be blank when selecting from a datalist
    } else if (data === "product.hsncode") {
      row.push({ style: ["notes", rowStyle], stack: [{ text: " " }] });
    } else if (data === "product.description") {
      row.push({ style: ["notes", rowStyle], stack: [{ text: " " }] });
    } else if (
      account.custom_invoice_item_label1 &&
      data === "product.custom_value1"
    ) {
      row.push({ style: ["customValue1", rowStyle], text: " " });
    } else if (
      account.custom_invoice_item_label2 &&
      data === "product.custom_value2"
    ) {
      row.push({ style: ["customValue2", rowStyle], text: " " });
    } else if (
      !hideQuantity &&
      (data === "product.cost" || data === "product.quantity")
    ) {
      if (data === "product.cost") {
        row.push({ style: ["tableHeader", rowStyle], text: " " });
      }

      var totalQty = 0;

      try {
        totalQty = invoice.totalQuantity + " ";
        if (totalBoxes > 0) {
          totalQty += " Box:" + totalBoxes + " Loose:" + totalLoose;
        }
      } catch (err) {
        totalQty = 0;
      }

      if (data === "product.quantity") {
        row.push({
          style: ["tableHeader", rowStyle],
          text: "Total " + totalQty || " ",
        });
      }
    } else if (data === "product.taxable_amount") {
      row.push({ style: ["cost", rowStyle], text: " " });
    } else if (showItemTaxes && data === "product.tax") {
      row.push({ style: ["tax", rowStyle], text: " " });
    } else if (showItemTaxes && data === "product.cess") {
      row.push({ style: ["tax", rowStyle], text: " " });
    } else if (data === "product.line_total") {
      row.push({ style: ["lineTotal", rowStyle], text: " " });
    } else if (data == "product.mrp") {
      row.push({ style: ["lineTotal", rowStyle], text: " " });
    } else if (data == "product.discount") {
      row.push({ style: ["lineTotal", rowStyle], text: " " });
    }
  });

  return row;
}

NINJA.invoiceDocuments = function (invoice) {
  if (invoice.account.invoice_embed_documents != "1") {
    return [];
  }

  var j = 0;
  var stack = [];
  var stackItem = null;

  if (invoice.documents) {
    for (var i = 0; i < invoice.documents.length; i++) {
      addDoc(invoice.documents[i]);
    }
  }

  if (invoice.expenses) {
    for (var i = 0; i < invoice.expenses.length; i++) {
      var expense = invoice.expenses[i];
      for (var j = 0; j < expense.documents.length; j++) {
        addDoc(expense.documents[j]);
      }
    }
  }

  function addDoc(document) {
    var path = document.base64;

    if (!path) path = "docs/" + document.public_id + "/" + document.name;
    if (path && (window.pdfMake.vfs[path] || subtotalsdocument.base64)) {
      // Only embed if we actually have an image for it
      if (j % 3 == 0) {
        stackItem = { columns: [] };
        stack.push(stackItem);
      }
      stackItem.columns.push({
        stack: [{ image: path, style: "invoiceDocument", fit: [150, 150] }],
        width: 175,
      });
      j++;
    }
  }

  return stack.length ? { stack: stack } : [];
};

NINJA.statementSubtotals = function (invoice) {
  var data = [
    [
      {
        text: invoiceLabels.balance_due,
        style: ["subtotalsLabel", "subtotalsBalanceDueLabel"],
      },
      {
        text: formatMoneyInvoice(invoice.balance_amount, invoice),
        style: ["subtotals", "subtotalsBalanceDue"],
      },
    ],
  ];

  return NINJA.prepareDataPairs(data, "subtotals");
};

NINJA.subtotals = function (invoice, hideBalance) {
  if (!invoice) {
    return;
  }

  var account = invoice.account;
  var data = [];

  var customValue1 = NINJA.parseFloat(invoice.custom_value1);
  var customValue1Label =
    customValue1 >= 0
      ? account.custom_invoice_label1 || invoiceLabels.surcharge
      : invoiceLabels.discount;

  var customValue2 = NINJA.parseFloat(invoice.custom_value2);
  var customValue2Label =
    customValue2 >= 0
      ? account.custom_invoice_label2 || invoiceLabels.surcharge
      : invoiceLabels.discount;

  if (invoice.is_dc == false || invoice.is_dc == undefined) {
    data.push([
      { text: "Total", style: ["subtotalsLabel"] },
      { text: invoice.formattedItemsTotal, style: ["subtotals", "subTotal"] },
    ]);

    if (customValue1 && invoice.custom_taxes1 == "1") {
      data.push([
        {
          text: customValue1Label,
          style: ["subtotalsLabel", "customTax1Label"],
        },
        {
          text: formatMoneyInvoice(invoice.custom_value1, invoice),
          style: ["subtotals", "customTax1"],
        },
      ]);
    }
    if (customValue2 && invoice.custom_taxes2 == "1") {
      data.push([
        {
          text: customValue2Label,
          style: ["subtotalsLabel", "customTax2Label"],
        },
        {
          text: formatMoneyInvoice(invoice.custom_value2, invoice),
          style: ["subtotals", "customTax2"],
        },
      ]);
    }

    if (customValue1 && invoice.custom_taxes1 != "1") {
      data.push([
        { text: customValue1Label, style: ["subtotalsLabel", "custom1Label"] },
        {
          text: formatMoneyInvoice(invoice.custom_value1, invoice),
          style: ["subtotals", "custom1"],
        },
      ]);
    }

    if (customValue2 && invoice.custom_taxes2 != "1") {
      data.push([
        { text: customValue2Label, style: ["subtotalsLabel", "custom2Label"] },
        {
          text: formatMoneyInvoice(invoice.custom_value2, invoice),
          style: ["subtotals", "custom2"],
        },
      ]);
    }

    if (invoice.total_taxable_amount != invoice.formattedItemsTotal) {
      data.push([
        { text: "Subtotal", style: ["subtotalsLabel"] },
        {
          text: invoice.total_taxable_amount,
          style: ["subtotals", "subTotal"],
        },
      ]);
    }

    if (
      invoice.account.show_custom_invoice_tax_amount1 == true &&
      customValue1 &&
      invoice.custom_taxes1 == "1"
    ) {
      data.push([
        {
          text: "Tax on " + customValue1Label,
          style: ["subtotalsLabel", "custom2Label"],
        },
        {
          text: invoice.custom_value1_tax_line,
          style: ["subtotals", "custom2"],
        },
      ]);
    }

    if (
      invoice.account.show_custom_invoice_tax_amount2 == true &&
      customValue2 &&
      invoice.custom_taxes2 == "1"
    ) {
      data.push([
        {
          text: "Tax on " + customValue2Label,
          style: ["subtotalsLabel", "custom2Label"],
        },
        {
          text: invoice.custom_value2_tax_line,
          style: ["subtotals", "custom2"],
        },
      ]);
    }

    if (invoice.rpt_total_sgst != "" && invoice.rpt_total_sgst > 0) {
      data.push([
        {
          text: invoiceLabels.total_tax1,
          style: ["subtotalsLabel", "taxLabel"],
        },
        {
          text: formatMoneyInvoice(invoice.rpt_total_sgst, invoice),
          style: ["subtotals", "tax"],
        },
      ]);
    }

    if (invoice.rpt_total_cgst != "" && invoice.rpt_total_cgst > 0) {
      data.push([
        {
          text: invoiceLabels.total_tax2,
          style: ["subtotalsLabel", "taxLabel"],
        },
        {
          text: formatMoneyInvoice(invoice.rpt_total_cgst, invoice),
          style: ["subtotals", "tax"],
        },
      ]);
    }

    if (invoice.rpt_total_igst != "" && invoice.rpt_total_igst > 0) {
      data.push([
        {
          text: invoiceLabels.total_tax3,
          style: ["subtotalsLabel", "taxLabel"],
        },
        {
          text: formatMoneyInvoice(invoice.rpt_total_igst, invoice),
          style: ["subtotals", "tax"],
        },
      ]);
    }

    if (invoice.raw_total_cess != "" && invoice.raw_total_cess > 0) {
      data.push([
        { text: "Total Cess", style: ["subtotalsLabel", "taxLabel"] },
        {
          text: formatMoneyInvoice(invoice.raw_total_cess, invoice),
          style: ["subtotals", "tax"],
        },
      ]);
    }

    if (invoice.raw_non_taxable_amount > 0) {
      data.push([
        {
          text: invoiceLabels.non_taxable_amount,
          style: ["subtotalsLabel", "taxLabel"],
        },
        {
          text: invoice.non_taxable_amount || " ",
          style: ["subtotals", "tax"],
        },
      ]);
    }

    if (invoice.account.show_total_tax == true) {
      data.push([
        { text: "Total Tax", style: ["subtotalsLabel", "taxLabel"] },
        {
          text: invoice.total_tax,
          style: ["subtotals", "tax"],
        },
      ]);
    }
  }

  //data.push([{text: 'Other Charges', style: ['subtotalsLabel', 'taxLabel']}, {text: invoice.non_taxable_amount, style: ['subtotals', 'tax']}]);

  if (invoice.discount_amount != 0) {
    data.push([
      {
        text: invoiceLabels.discount,
        style: ["subtotalsLabel", "discountLabel"],
      },
      {
        text: formatMoneyInvoice(invoice.discount_amount, invoice),
        style: ["subtotals", "discount"],
      },
    ]);
  }

  if (invoice.account.show_roundoff == true) {
    data.push([
      { text: "Rounding off", style: ["subtotalsLabel", "customTax2Label"] },
      {
        text: formatMoneyInvoice(invoice.round_off, invoice),
        style: ["subtotals", "customTax2"],
      },
    ]);
  }

  if (data.length <= 2) {
    data.push([
      { text: " ", style: ["subtotalsLabel", "customTax2Label"] },
      { text: " ", style: ["subtotals", "customTax2"] },
    ]);
  }

  return NINJA.prepareDataPairs(data, "subtotals");
};

(NINJA.paidAmount = function (invoice) {
  var amount = 0;
  amount = formatMoneyInvoice(invoice.paid, invoice);

  if (invoice.account.show_balance_due == false) {
    return [
      [
        { text: " ", style: ["subtotalsLabel", "subtotalsBalanceDueLabel"] },
        { text: " ", style: ["subtotals", "subtotalsBalanceDue"] },
      ],
    ];
  } else {
    return [
      [
        {
          text: "Paid Till Date",
          style: ["subtotalsLabel", "subtotalsBalanceDueLabel"],
        },
        { text: amount, style: ["subtotals", "subtotalsBalanceDue"] },
      ],
    ];
  }
}),
  (NINJA.subtotalsBalance = function (invoice) {
    var isPartial = NINJA.parseFloat(invoice.partial);

    var totalLabel = invoice.is_statement ? "Balance Due" : "Total";

    var amount = 0;
    if (invoice.is_statement) {
      amount = formatMoneyInvoice(invoice.client.balance, invoice);
    } else {
      amount = formatMoneyInvoice(invoice.total_invoice_amount, invoice);
    }

    var items = [];

    if (invoice.totalDiscount > 0) {
      items.push([
        {
          text: invoiceLabels.discount,
          style: ["subtotalsLabel", "subtotalsBalanceDueLabel"],
        },
        {
          text: formatMoneyInvoice(invoice.totalDiscount, invoice),
          style: ["subtotals", "subtotalsBalanceDue"],
        },
      ]);
    }

    items.push([
      {
        text: totalLabel,
        style: ["subtotalsLabel", "subtotalsBalanceDueLabel"],
      },
      { text: amount, style: ["subtotals", "subtotalsBalanceDue"] },
    ]);

    return items;
  }),
  (NINJA.taxableAmount = function (invoice) {
    var data = [];
    var amount = 0;

    if (!invoice.total_taxable_amount) {
      data.push([
        {
          text: invoiceLabels.taxable_amount,
          style: ["subtotalsLabel", "subtotalLabel"],
        },
        { text: "Rs. 0.00", style: ["subtotals", "subtotal"] },
      ]);
    } else {
      data.push([
        {
          text: invoiceLabels.taxable_amount,
          style: ["subtotalsLabel", "subtotalLabel"],
        },
        {
          text: invoice.total_taxable_amount,
          style: ["subtotals", "subtotal"],
        },
      ]);
    }

    return NINJA.prepareDataPairs(data, "subtotals");
  });

(NINJA.subtotalsBalanceDue = function (invoice) {
  var isPartial = NINJA.parseFloat(invoice.partial);
  var amount = 0;

  if (invoice.is_statement) {
    amount = invoice.subtotal_amount;
  } else {
    amount = invoice.total_amount;
  }

  if (invoice.account.show_balance_due == false) {
    return [
      [
        { text: " ", style: ["subtotalsLabel", "subtotalsBalanceDueLabel"] },
        { text: " ", style: ["subtotals", "subtotalsBalanceDue"] },
      ],
    ];
  } else {
    return [
      [
        {
          text:
            invoice.is_quote || invoice.is_statement
              ? ""
              : invoiceLabels.balance_due,
          style: ["subtotalsLabel", "subtotalsBalanceDueLabel"],
        },
        {
          text:
            invoice.is_quote || invoice.is_statement
              ? ""
              : formatMoneyInvoice(amount, invoice),
          style: ["subtotals", "subtotalsBalanceDue"],
        },
      ],
    ];
  }
}),
  (NINJA.subtotalsBalanceInWords = function (invoice) {
    var isPartial = NINJA.parseFloat(invoice.partial);

    var amount = 0;
    if (invoice.is_statement) {
      amount = invoice.client.balance;
    } else {
      amount = invoice.total_invoice_amount;
    }

    return "Total amount (in words)\n\n" + amountInWord(amount, invoice);
  });

NINJA.accountDetails = function (invoice) {
  var account = invoice.account;
  if (invoice.features.invoice_settings && account.invoice_fields) {
    var fields = JSON.parse(account.invoice_fields).account_fields1;
  } else {
    var fields = [
      "account.company_name",
      "account.id_number",
      "account.vat_number",
      "account.website",
      "account.email",
      "account.phone",
    ];
  }

  var data = [];

  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var value = NINJA.renderField(invoice, field);
    if (value) {
      if (i < fields.length - 2) {
        value.text += ", ";
      }
      data.push(value);
    }
  }

  return NINJA.prepareDataList(data, "accountDetails");
};

NINJA.accountAddress = function (invoice) {
  var account = invoice.account;
  if (invoice.features.invoice_settings && account.invoice_fields) {
    var fields = JSON.parse(account.invoice_fields).account_fields2;
  } else {
    var fields = [
      "account.address1",
      "account.address2",
      "account.city_state_postal",
      "account.country",
      "account.custom_value1",
      "account.custom_value2",
    ];
  }

  var data = [];

  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var value = NINJA.renderField(invoice, field);

    if (value) {
      if (i < fields.length - 1) {
        value.text += ", ";
      }
      data.push(value);
    }
  }

  return NINJA.prepareDataList(data, "accountAddress");
};

NINJA.invoiceDetails = function (invoice) {
  var account = invoice.account;
  if (invoice.features.invoice_settings && account.invoice_fields) {
    var fields = JSON.parse(account.invoice_fields).invoice_fields;
  } else {
    var fields = [
      "invoice.invoice_type",
      "invoice.invoice_number",
      "invoice.po_number",
      "invoice.invoice_date",
      "invoice.due_date",
      "invoice.balance_due",
      "invoice.partial_due",
      "invoice.custom_text_value1",
      "invoice.custom_text_value2",
      "invoice.inextra_1",
      "invoice.inextra_2",
      "invoice.inextra_3",
      "invoice.inextra_4",
      "invoice.inextra_5",
      "invoice.inextra_6",
      "invoice.inextra_7",
      "invoice.inextra_8",
    ];
  }

  if (fields.indexOf("invoice.inextra_8") != -1) {
    fields.splice(fields.indexOf("invoice.inextra_8"), 1);
  }

  var data = [];

  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];

    var value = NINJA.renderField(invoice, field, true);
    if (value) {
      data.push(value);
    }
  }

  return NINJA.prepareDataPairs(data, "invoiceDetails");
};

NINJA.renderField = function (invoice, field, twoColumn) {
  var client = invoice.client;
  if (!client) {
    return false;
  }
  var account = invoice.account;
  var contact = client.contacts[0];
  var clientName =
    client.name ||
    (contact.first_name || contact.last_name
      ? contact.first_name + " " + contact.last_name
      : contact.email);

  var label = false;
  var value = false;

  var description = new Object();
  var notes = " ";

  if (IsJsonString(invoice.private_notes)) {
    description = JSON.parse(invoice.private_notes);
  } else {
    notes = invoice.private_notes;
  }

  if (field == "client.client_name") {
    value = clientName || " ";
  } else if (field == "client.contact_name") {
    value =
      contact.first_name || contact.last_name
        ? contact.first_name + " " + contact.last_name
        : false;
  } else if (field == "client.id_number") {
    value = client.id_number;
    if (invoiceLabels.id_number_orig) {
      label = invoiceLabels.id_number;
    }
  } else if (field == "client.vat_number") {
    value = client.vat_number;
    label = invoiceLabels.vat_number;
  } else if (field == "client.address1") {
    value = client.address1 + "\n" + client.address2;
    var postalCityState = formatAddress(
      client.city,
      client.statename,
      client.postal_code
    );

    value += "\n" + postalCityState;
  } else if (field == "client.address2") {
    value = "";
  } else if (field == "client.city_state_postal") {
    var cityStatePostal = "";
    if (client.city || client.statename || client.postal_code) {
      var swap = client.country && client.country.swap_postal_code;
      cityStatePostal = formatAddress(
        client.city,
        client.statename,
        client.postal_code,
        swap
      );
    }
    value = cityStatePostal;
  } else if (field == "client.postal_city_state") {
    var postalCityState = "";
    if (client.city || client.statename || client.postal_code) {
      postalCityState = formatAddress(
        client.city,
        client.statename,
        client.postal_code,
        true
      );
    }
    value = postalCityState;
  } else if (field == "client.country") {
    value = client.country ? client.country.name : "";
  } else if (field == "client.email") {
    value = contact.email == clientName ? "" : contact.email;
  } else if (field == "client.phone") {
    value = contact.phone;
  } else if (field == "client.custom_value1") {
    if (account.custom_client_label1 && client.custom_value1) {
      label = account.custom_client_label1;
      value = client.custom_value1;
    }
  } else if (field == "client.custom_value2") {
    if (account.custom_client_label2 && client.custom_value2) {
      label = account.custom_client_label2;
      value = client.custom_value2;
    }
  } else if (field == "contact.custom_value1") {
    if (account.custom_contact_label1 && contact.custom_value1) {
      label = account.custom_contact_label1;
      value = contact.custom_value1;
    }
  } else if (field == "contact.custom_value2") {
    if (account.custom_contact_label2 && contact.custom_value2) {
      label = account.custom_contact_label2;
      value = contact.custom_value2;
    }
  } else if (field == "account.company_name") {
    value = account.name;
  } else if (field == "account.id_number") {
    value = account.id_number;
    if (invoiceLabels.id_number_orig) {
      label = "\n" + invoiceLabels.id_number;
    }
  } else if (field == "account.vat_number") {
    value = account.vat_number;
    label = "\n" + invoiceLabels.vat_number;
  } else if (field == "account.website") {
    value = account.website;
  } else if (field == "account.email") {
    value = account.work_email;
  } else if (field == "account.phone") {
    value = account.work_phone;
  } else if (field == "account.address1") {
    value = account.address1;
  } else if (field == "account.address2") {
    value = account.address2;
  } else if (field == "account.city_state_postal") {
    var cityStatePostal = "";

    var accountState = "";
    if (
      account.accountstate != null &&
      account.accountstate.full_name != null
    ) {
      accountState = account.accountstate.full_name;
    }

    if (account.city || accountState || account.postal_code) {
      var swap = account.country && account.country.swap_postal_code;
      cityStatePostal = formatAddress(
        account.city,
        accountState,
        account.postal_code,
        swap
      );
    }
    value = cityStatePostal;
  } else if (field == "account.postal_city_state") {
    var postalCityState = "";
    var accountState = "";
    if (
      account.accountstate != null &&
      account.accountstate.full_name != null
    ) {
      accountState = account.accountstate.full_name;
    }
    if (account.city || accountState || account.postal_code) {
      postalCityState = formatAddress(
        account.city,
        accountState,
        account.postal_code,
        true
      );
    }
    value = postalCityState;
  } else if (field == "account.country") {
    value = account.country ? account.country.name : false;
  } else if (field == "account.custom_value1") {
    if (invoice.account.custom_label1 && invoice.account.custom_value1) {
      label = invoice.account.custom_label1;
      value = invoice.account.custom_value1;
    }
  } else if (field == "account.custom_value2") {
    if (invoice.account.custom_label2 && invoice.account.custom_value2) {
      label = invoice.account.custom_label2;
      value = invoice.account.custom_value2;
    }
  } else if (field == "invoice.invoice_number") {
    if (invoice.is_dc) {
      label = invoiceLabels.delivery_challan_number;
    } else if (!invoice.is_statement) {
      label = invoice.is_debit_note
        ? invoiceLabels.debit_note_number
        : invoice.is_po
        ? invoiceLabels.purchase_number
        : invoice.is_quote
        ? invoiceLabels.quote_number
        : invoice.balance_amount < 0
        ? invoiceLabels.credit_number
        : invoiceLabels.invoice_number;
    }
    value = invoice.invoice_number;
  } else if (field == "invoice.po_number") {
    value = invoice.po_number;
  } else if (field == "invoice.invoice_date") {
    if (invoice.is_dc) {
      label = invoiceLabels.dc_date;
    } else {
      label = invoice.is_debit_note
        ? invoiceLabels.debit_note_date
        : invoice.is_po
        ? invoiceLabels.purchase_date
        : invoice.is_statement
        ? invoiceLabels.statement_date
        : invoice.is_quote
        ? invoiceLabels.quote_date
        : invoice.balance_amount < 0
        ? invoiceLabels.credit_date
        : invoiceLabels.invoice_date;
    }

    value = invoice.invoice_date;
  } else if (field == "invoice.due_date") {
    if (invoice.is_dc) {
      //hide due
    } else {
      label = invoice.is_quote
        ? invoiceLabels.valid_until
        : invoiceLabels.due_date;
      value = invoice.is_recurring ? false : invoice.due_date;
    }
  } else if (field == "invoice.invoice_type") {
    label = "";
    value = invoice.invoice_type;
  } else if (field == "invoice.custom_text_value1") {
    if (invoice.custom_text_value1 && account.custom_invoice_text_label1) {
      label = invoice.account.custom_invoice_text_label1;
      value = invoice.is_recurring
        ? processVariables(invoice.custom_text_value1)
        : invoice.custom_text_value1;
    }
  } else if (field == "invoice.custom_text_value2") {
    if (invoice.custom_text_value2 && account.custom_invoice_text_label2) {
      label = invoice.account.custom_invoice_text_label2;
      value = invoice.is_recurring
        ? processVariables(invoice.custom_text_value2)
        : invoice.custom_text_value2;
    }
  } else if (field == "invoice.balance_due") {
    if (invoice.is_dc) {
    } else {
      label = invoice.is_po
        ? "Purchase Total"
        : invoice.is_quote
        ? "Total"
        : invoice.is_statement
        ? "Balance Due"
        : "Invoice Total";

      var amount = 0;
      if (invoice.is_statement) {
        amount = invoice.client.balance;
      } else {
        amount = invoice.total_invoice_amount;
      }
      value = formatMoneyInvoice(amount, invoice);
    }
  } else if (field == invoice.partial_due) {
    if (NINJA.parseFloat(invoice.partial)) {
      label = invoiceLabels.partial_due;
      value = formatMoneyInvoice(invoice.balance_amount, invoice);
    }
  } else if (field == "invoice.invoice_total") {
    if (
      invoice.is_dc ||
      invoice.is_statement ||
      invoice.is_quote ||
      invoice.balance_amount < 0
    ) {
      // hide field
    } else {
      value = formatMoneyInvoice(invoice.amount, invoice);
    }
  } else if (field == "invoice.outstanding") {
    if (invoice.is_statement || invoice.is_quote) {
      // hide field
    } else {
      value = formatMoneyInvoice(client.balance, invoice);
    }
  } else if (field == ".blank") {
    value = " ";
  } else if (field == "invoice.inextra_1") {
    label = invoiceLabels.inextra_1;
    value = description.inextra_1;
  } else if (field == "invoice.inextra_2") {
    label = invoiceLabels.inextra_2;
    value = description.inextra_2;
  } else if (field == "invoice.inextra_3") {
    label = invoiceLabels.inextra_3;
    value = description.inextra_3;
  } else if (field == "invoice.inextra_4") {
    label = invoiceLabels.inextra_4;
    value = description.inextra_4;
  } else if (field == "invoice.inextra_5") {
    label = invoiceLabels.inextra_5;
    value = description.inextra_5;
  } else if (field == "invoice.inextra_6") {
    label = invoiceLabels.inextra_6;
    value = description.inextra_6;
  } else if (field == "invoice.inextra_7") {
    label = invoiceLabels.inextra_7;
    value = description.inextra_7;
  } else if (field == "invoice.inextra_8") {
    return "";
  } else if (field == "client.inextra_8") {
    label = invoiceLabels.inextra_8;
    value = description.inextra_8;
  } else if (field == "client.state_of_supply") {
    label = invoiceLabels.state_of_supply;
    var state = states.find(function (obj) {
      return obj.id == invoice.state_of_supply;
    });
    if (state) {
      value = state.full_name;
    } else {
      value = "";
    }
  }

  if (value) {
    var shortField = false;
    var parts = field.split(".");
    if (parts.length >= 2) {
      var shortField = parts[1];
    }
    var style = snakeToCamel(
      shortField == "company_name" ? "account_name" : shortField
    ); // backwards compatibility
    if (twoColumn) {
      // try to automatically determine the label
      if (!label && label != "Blank") {
        if (invoiceLabels[shortField]) {
          label = invoiceLabels[shortField];
        }
      }
      return [
        { text: label, style: [style + "Label"] },
        { text: value, style: [style] },
      ];
    } else {
      // if the label is set prepend it to the value
      if (label) {
        value = label + ": " + value;
      }
      return { text: value, style: [style] };
    }
  } else {
    return false;
  }
};

NINJA.clientDetails = function (invoice) {
  var account = invoice.account;
  if (invoice.features.invoice_settings && account.invoice_fields) {
    var fields = JSON.parse(account.invoice_fields).client_fields;
  } else {
    var fields = [
      "client.client_name",
      "client.id_number",
      "client.vat_number",
      "client.address1",
      "client.address2",
      "client.city_state_postal",
      "client.country",
      "client.email",
      "client.custom_value1",
      "client.custom_value2",
      "contact.custom_value1",
      "contact.custom_value2",
    ];
  }

  if (invoice.inextra_8) {
    fields.push("client.inextra_8");
  }

  var data = [];

  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var value = NINJA.renderField(invoice, field, true);
    if (value) {
      data.push(value);
    }
  }

  if (invoice.deliveryaddress && invoice.deliveryaddress.public_id) {
    var deliveryInfo = NINJA.deliveryDetails(invoice);
    if (deliveryInfo) {
      data.push([
        { text: "Delivery Details", style: ["deliveryDetailsLabel"] },
        { text: deliveryInfo, style: ["deliveryDetails"] },
      ]);
    }
  }
  

  return NINJA.prepareDataPairs(data, "clientDetails");
};

NINJA.deliveryDetails = function (invoice) {
  if (!invoice.deliveryaddress || !invoice.deliveryaddress.public_id) {
    return "";
  }

  var account = invoice.account;
  var deliveryInfo = "";

  if (invoice.deliveryaddress.name) {
    deliveryInfo += "Deliver to: " + invoice.deliveryaddress.name + "\n";
  }

  if (invoice.deliveryaddress.first_name || invoice.deliveryaddress.last_name) {
    var contactPerson =
      (invoice.deliveryaddress.first_name || "") +
      " " +
      (invoice.deliveryaddress.last_name || "");
    deliveryInfo += "Attendee: " + contactPerson.trim() + "\n";
  }

  if (invoice.deliveryaddress.state) {
    var address =
      (invoice.deliveryaddress.address1 || "") +
      ", " +
      (invoice.deliveryaddress.address2 || "") +
      ", " +
      (invoice.deliveryaddress.city || "") +
      ", ";

    if (invoice.deliveryaddress.state) {
      address += invoice.deliveryaddress.state.full_name + ", ";
    }

    if (invoice.deliveryaddress.country) {
      address += invoice.deliveryaddress.country.name + ", ";
    }

    address += invoice.deliveryaddress.postal_code;
    deliveryInfo += "Delivery Address: " + address;
  }

  return deliveryInfo.trim();
};

NINJA.getPrimaryColor = function (defaultColor) {
  return NINJA.primaryColor ? NINJA.primaryColor : defaultColor;
};

NINJA.getSecondaryColor = function (defaultColor) {
  return NINJA.primaryColor ? NINJA.secondaryColor : defaultColor;
};

// remove blanks and add section style to all elements
NINJA.prepareDataList = function (oldData, section) {
  var newData = [];
  if (!oldData.length) {
    oldData.push({ text: " " });
  }
  for (var i = 0; i < oldData.length; i++) {
    var item = NINJA.processItem(oldData[i], section);
    if (item.text || item.stack) {
      newData.push(item);
    }
  }
  return newData;
};

NINJA.prepareDataTable = function (oldData, section) {
  var newData = [];
  for (var i = 0; i < oldData.length; i++) {
    var row = oldData[i];
    var newRow = [];
    for (var j = 0; j < row.length; j++) {
      var item = NINJA.processItem(row[j], section);
      if (item.text || item.stack) {
        newRow.push(item);
      }
    }
    if (newRow.length) {
      newData.push(newRow);
    }
  }
  return newData;
};

NINJA.prepareDataPairs = function (oldData, section) {
  var newData = [];
  if (!oldData.length) {
    oldData.push([{ text: " " }, { text: " " }]);
  }
  for (var i = 0; i < oldData.length; i++) {
    var row = oldData[i];
    var isBlank = false;
    for (var j = 0; j < row.length; j++) {
      var item = NINJA.processItem(row[j], section);
      if (!item.text) {
        isBlank = true;
      }
      if (j == 1) {
        NINJA.processItem(row[j], section + "Value");
      }
    }
    if (!isBlank) {
      newData.push(oldData[i]);
    }
  }
  return newData;
};

NINJA.processItem = function (item, section) {
  if (item.style && item.style instanceof Array) {
    item.style.push(section);
  } else {
    item.style = [section];
  }
  return item;
};

NINJA.parseMarkdownText = function (val, groupText) {
  var rules = [
    ["\\*\\*(\\w.+?)\\*\\*", { bold: true }], // **value**
    ["\\*(\\w.+?)\\*", { italics: true }], // *value*
    ["^###(.*)", { style: "help" }], // ### Small/gray help
    ["^##(.*)", { style: "subheader" }], // ## Header
    ["^#(.*)", { style: "header" }], // # Subheader
  ];

  var parts = typeof val === "string" ? [val] : val;
  for (var i = 0; i < rules.length; i++) {
    var rule = rules[i];
    var formatter = function (data) {
      return $.extend(data, rule[1]);
    };
    parts = NINJA.parseRegExp(parts, rule[0], formatter, true);
  }

  return parts.length > 1 ? parts : val;
};

/*
 NINJA.parseMarkdownStack = function(val)
 {
 if (val.length == 1) {
 var item = val[0];
 var line = item.hasOwnProperty('text') ? item.text : item;

 if (typeof line === 'string') {
 line = [line];
 }

 var regExp = '^\\\* (.*[\r\n|\n|\r]?)';
 var formatter = function(data) {
 return {"ul": [data.text]};
 }

 val = NINJA.parseRegExp(line, regExp, formatter, false);
 }

 return val;
 }
 */

NINJA.parseRegExp = function (val, regExpStr, formatter, groupText) {
  var regExp = new RegExp(regExpStr, "gm");
  var parts = [];

  for (var i = 0; i < val.length; i++) {
    var line = val[i];
    parts = parts.concat(
      NINJA.parseRegExpLine(line, regExp, formatter, groupText)
    );
  }

  return parts.length > 1 ? parts : val;
};

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

NINJA.parseRegExpLine = function (line, regExp, formatter, groupText) {
  var parts = [];
  var lastIndex = -1;

  while ((match = regExp.exec(line))) {
    if (match.index > lastIndex) {
      parts.push(line.substring(lastIndex, match.index));
    }
    var data = {};
    data.text = match[1];
    data = formatter(data);
    parts.push(data);
    lastIndex = match.index + match[0].length;
  }

  if (parts.length) {
    if (lastIndex < line.length) {
      parts.push(line.substring(lastIndex));
    }
    return parts;
  }

  return line;
};
